import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Form, Modal, Button } from "react-bootstrap";
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "../shareable-images/shareable-images.css";
//import DataTable from "react-data-table-component";
import { Image } from "../../../../assets/images";
import { edit } from "../../../../assets/images";
import { DeleteIcon } from "../../../../assets/images";
import axios from "../../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../../utils/adminConfig";

const PartnerSection = () => {
  const [loading, setLoading] = useState(false);
  const [cals, setCals] = useState([]);
  const [show, setShow] = useState(false);

  const [editfile, seteditFile] = useState("");
  const [edittitle, seteditTitle] = useState("");
  const [editurl, seteditUrl] = useState("");
  const [editId, seteditId] = useState("");
  const [editDesc, setEditDesc] = useState("");
  const [deleteShow, setdeleteShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const handleClose = () => setShow(false);
  const handleCloseDelete = () => setdeleteShow(false);

  const updateCalendar = async (e) => {
    e.preventDefault();

    setLoading(true);
    let data = new FormData();

    data.append("image", editfile);
    data.append("title", edittitle);
    data.append("url", editurl);
    data.append("editId", editId);
    data.append("desc", editDesc);

    await axios
      .post(`/update-preferred-partners`, data, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          seteditFile("");
          seteditTitle("");
          seteditUrl("");
          seteditId("");
          setEditDesc("");
          getAllPartner();
          setShow(false);
          message.success("Partner Updated Successfully");
        } else {
          message.error("failed adding Image");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };

  const getAllPartner = async () => {
    setLoading(true);
    axios
      .get(`/get-preferred-partner`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setCals(res.data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getEditData = (id) => {
    setLoading(true);
    axios
      .get(`/get-preferred-partner-edit-data/${id}`)
      .then((res) => {
        setLoading(false);
        seteditTitle(res.data.data.title);
        seteditUrl(res.data.data.url);
        seteditId(id);
        setEditDesc(res.data.data.desc);
        setShow(true);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const deleteData = (id) => {
    setDeleteId(id);
    setdeleteShow(true);
  };

  const deleteCal = () => {
    setLoading(true);
    axios
      .get(`/delete-preferred-data/${deleteId}`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setdeleteShow(false);
          getAllPartner();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAllPartner();
  }, []);

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="image_gallery">
              <h2>All Preferred Partners</h2>
              <div className="gallery_inner">
                {cals.length > 0 &&
                  cals.map((cal, key) => {
                    return (
                      <div className="gallery_inner_inner" key={key}>
                        <div className="gallery_box gb_partner">
                          <div className="gb_action">
                            <img
                              src={edit}
                              alt="edit"
                              className="gb_edit"
                              width={40}
                              height={40}
                              onClick={() => {
                                getEditData(cal._id);
                              }}
                            />

                            <img
                              src={DeleteIcon}
                              alt="Delete"
                              width={40}
                              height={40}
                              onClick={() => {
                                deleteData(cal._id);
                              }}
                            />
                          </div>
                          <a
                            href={cal.imageUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img src={cal.imageUrl} alt="" />
                          </a>

                          <div className="domain_name">
                            <h4>{cal.title}</h4>
                            <p>{cal.desc}</p>
                            <div>
                              <a
                                className="btn btn-primary"
                                href={cal.url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Go To Link
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>Preferred Partners Edit</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-lg">
          <Form onSubmit={updateCalendar}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Enter Heading</Form.Label>
              <Form.Control
                type="text"
                value={edittitle}
                onChange={(e) => {
                  seteditTitle(e.target.value);
                }}
                placeholder="Enter Heading"
                className="text_link"
                required
              />
            </Form.Group>
            <div className="upload_pdf">
              <h3>
                Upload Image (optional) <br />
                <small>(Image resolution should be 1024*680)</small>
              </h3>
              <div className="upload_btn_wrapper">
                <button className="btn_bulk">
                  <span className="cert_bulkks">
                    <img src={Image} alt="" />
                  </span>
                  {editfile ? (
                    editfile.name
                  ) : (
                    <>
                      Upload Image
                      <input
                        type="file"
                        name="myfile"
                        onChange={(e) => {
                          // console.log(e.target.files[0]);
                          seteditFile(e.target.files[0]);
                        }}
                      />
                    </>
                  )}
                </button>
              </div>
            </div>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Enter URL</Form.Label>
              <Form.Control
                type="text"
                value={editurl}
                onChange={(e) => {
                  seteditUrl(e.target.value);
                }}
                placeholder="Enter URL"
                className="text_link"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Enter Description</Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                rows={5}
                value={editDesc}
                onChange={(e) => {
                  setEditDesc(e.target.value);
                }}
                placeholder="Enter Description"
                className="text_link"
                required
              />
            </Form.Group>
            <div className="sub_but">
              <button
                type="submit"
                // onClick={}
                className="add_but submit_buttt mt-0"
              >
                Update
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={deleteShow} onHide={handleCloseDelete}>
        {/* <Modal.Header closeButton>
        </Modal.Header> */}
        <Modal.Body>
          <h4 className="text-center">Are you sure you want to delete?</h4>
          <div className="yes_no_but d-flex align-items-center justify-content-center">
            <Button variant="secondary" className="yes_but" onClick={deleteCal}>
              Yes
            </Button>
            <Button
              variant="primary"
              className="no_but"
              onClick={handleCloseDelete}
            >
              No
            </Button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          
        </Modal.Footer> */}
      </Modal>
    </LoadingOverlay>
  );
};

export default PartnerSection;
